import DashboardPage from "@/pages/Dashboard";
export default [
  {
    path: "/home",
    name: "HomePage",
    component: DashboardPage,
    props: { dashboardPage: "home", headerMode: "full" }
  },
  {
    path: "/explore",
    name: "ExplorePage",
    component: DashboardPage,
    props: { dashboardPage: "explore", headerMode: "full" }
  },
  {
    path: "/projects",
    name: "ProjectsPage",
    component: DashboardPage,
    props: { dashboardPage: "project", headerMode: "full" }
  },
  {
    path: "/tasks",
    name: "TasksPage",
    component: DashboardPage,
    props: { dashboardPage: "tasks", headerMode: "full" }
  },
  {
    path: "/people",
    name: "PeoplePage",
    component: DashboardPage,
    props: { dashboardPage: "people", headerMode: "full" }
  },
  {
    path: "/company",
    name: "CompanyPage",
    component: DashboardPage,
    props: {
      dashboardPage: "company",
      headerMode: "full",
      subPage: "company"
    }
  },
  {
    path: "/profile",
    name: "ProfilePage",
    component: DashboardPage,
    props: { dashboardPage: "profile", headerMode: "full" }
  },
  {
    path: "/billing",
    name: "BillingPage",
    component: DashboardPage,
    props: { dashboardPage: "billing", headerMode: "full" }
  }
];
